export const contractAddress =
  'erd1qqqqqqqqqqqqqpgq34y5ecvv74t2an67tpj9lhfqzxpn2pt7u5lqns3c92'; // prod
//'erd1qqqqqqqqqqqqqpgqkd2yr3dz72lurpwl7pmfzykp0vzgtafgptyskwty0a'; // dev

export const dAppName = 'eDoodle';
